<template>
    <div class="economy">
        <el-container>
            <el-header>
                <v-head :active="2" :bannerData="bannerData" :isBanner="true" :color="'black'" indicator="none"></v-head>
            </el-header>
            <el-main>
                <div class="" style="padding-bottom: 48px;margin-top: -80px;">
                    <div>
                        <img src="@img/economy/pic_zqgj.png" alt="">
                    </div>
                    <div class="tabs">
                        <div class="tab" @click="tab_fn(0)">应用场景
                            <div class="underline" :class=" is_active === 0 ? 'is_active' : '' "></div>
                        </div>
                        
                        <div class="tab" @click="tab_fn(1)">产品家族
                            <div class="underline" :class=" is_active === 1 ? 'is_active' : '' "></div>
                        </div>
                        <div class="tab" @click="tab_fn(2)">AI+ 创新技术
                            <div class="underline" :class=" is_active === 2 ? 'is_active' : '' "></div>
                        </div>
                    </div>
                    <div class="container">
                        <div v-if="is_active === 0">
                            <div class="sceneList" >
                                <div>
                                    <img src="@img/economy/Group262.png" alt="">
                                </div>
                                
                                
                                <!-- <div class="sceneItem" v-for="(item, index) in sceneList" :key="index">
                                    <div class="pic">
                                        <img :src="item.img" alt="">
                                    </div>
                                    <div class="title">{{ item.name }}</div>
                                    <div class="description">{{ item.content }}</div>
                                </div> -->
                            </div>
                        </div>
                        
                        <div v-if="is_active === 1">
                            <div>
                                <img src="@img/economy/pic_dzzcxh.png" alt="">
                            </div>
                            <div class="tab_title">UAV 产品家族</div>
                            <div>
                                <img class="picWidth" src="@img/economy/pic_uavargument.png" alt="">
                            </div>
                            <div class="margin-_top">
                                <img src="@img/economy//pic_cpys.png" alt="">
                            </div>
                            
                        </div>
                        <div v-if="is_active === 2">
                            <div class="ai">
                                <div class="tab_title">构建低空基础设施，为产业发展注入新活力</div>
                                <div class="detail aiTec">
                                    <img src="@img/economy/pic_uavjcjs.png" alt="">
                                </div>
                                <div class="margin-_top">
                                    <img src="@img/economy//Group223.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-main>
            <el-footer style="background:#f4f6f9;">
                <v-footer></v-footer>
            </el-footer>
        </el-container>

    </div>
</template>
<script>
import vHead from "../components/head.vue";
import vFooter from "../components/footer.vue";
export default {

    data() {
        return {
            is_active: 0,
            topBannerList: [],
            bannerData: [
                {
                title: "无人机AI+创新技术践行者",
                content: 
                    "低空基础设施软硬件一体化解决方案提供商",
                button: "获取专属方案", 
                img: require("@img/economy/economy-banner1.jpg"),
                banner: "economy"
                }
            ],
            sceneList: [
                {
                    name: '应急救援',
                    content: '灾情侦察与响应：无人机搭载高清摄像头与热成像设备，实时传输灾害现场影像，为救援决策提供关键数...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '森林消防',
                    content: '火情监测与预警：无人机通过红外热成像技术识别早期火源，结合GIS系统生成火势蔓延模型，提升森林火...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '电力巡检',
                    content: '线路隐患排查：无人机沿电网自主巡航，利用激光雷达与高清摄像头检测输电线路断股、绝缘子破损等问题...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '低空物流',
                    content: '包括大宗物资运输和寄件物流配送，实现不同区域条件下物资的低成本快速送达...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '水域环保',
                    content: '湖泊巡检采用多旋翼无人机巡检，智能监察测隐患，降本增效，联动处置护生态...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '边防海事',
                    content: '执行非法占用航道、船舶引航、大雾引航、水上搜寻救助及水上交通事故处理等任务...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '低空文旅',
                    content: '充分活化利用景点历史价值，规划“空中观光走廊”，为用户提供景观飞巡业务，体会春夏秋冬不同美景...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '城市数字治理',
                    content: '充分活化利用景点历史价值，规划“空中观光走廊”，为用户提供景观飞巡业务，体会春夏秋冬不同美景...',
                    img: require("../../public/img/test.png")
                },
                {
                    name: '新能源（风电/光伏）',
                    content: '执行新能源风机、光伏和外送线路实时巡检...',
                    img: require("../../public/img/test.png")
                },
            ]
        }
    },
    components: {
        vHead,
        vFooter
    },
    created() {

    },
    methods: {
        tab_fn(val) {
            this.is_active = val
        }
    }

}
</script>
<style lang="scss" scoped>
.tabs{
    width: 1200px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 30px auto;
    .tab{
        min-width: 250px;
        height: 60px;
        padding-top: 10px;
        font-size: 32px;
    }
    .is_active{
        margin-top: 3px;
        height: 4px;
        background-color: #0000ff;
        width: 100%;
        transition: width 0.3s ease;
    }
}
.container{
    .margin-_top{
        margin-top: 30px;
    }

    .ai{
        .tab_title{
            font-size: 28px;
            color: #1c205d;
            margin: 40px auto;
        }
        .detail{
            scale: 0.9;
        }
    }
    .tab_title{
        font-size: 26px;
        color: #1c205d;
        margin: 40px auto;
    }
    
    .sceneList{
        width: 1200px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .sceneItem{
            width: 386px;
            background: #fafcfe;
            margin-bottom: 20px;
            .pic{
                width: 386px;
                height: 240px;
            }
            .title{
                text-align: center;
                margin: 20px auto;
                font-size: 18px;
                font-weight: bold;
            }
            .description{
                text-align: left;
                padding: 0 20px 20px;
                color: #6E747A;
                font-size: 14px;
            }
        }
    }
}
img{
    width: 1200px;
}
.banner{
    width: 100%;
    img{
        width: 100%;
    }
}
</style>